import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';

export interface IItemInspecao {
  numero: number;
  id: string;
  descricao: string;
}

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent implements OnInit, OnChanges {
  @Input() itens: IItemInspecao[] = [];
  @Input() formArray!: FormArray;

  isOpen = false;

  observacaoControls: FormControl[] = [];

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initializeFormArray();
    this.initializeControls();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['itens'] && this.itens.length > 0) {
      this.initializeFormArray();
      this.initializeControls();
    }

    if (changes['formArray']) {
      this.initializeControls();
    }
  }

  private initializeFormArray(): void {
    if (!this.formArray) {
      console.warn('FormArray não fornecido ao componente accordion');
      return;
    }

    const currentLength = this.formArray.length;
    const desiredLength = this.itens.length;

    if (currentLength < desiredLength) {
      for (let i = currentLength; i < desiredLength; i++) {
        const item = this.itens[i];
        this.formArray.push(
          this.fb.group({
            perguntaId: [item.id],
            perguntaNumero: [item.numero],
            perguntaTexto: [item.descricao],
            resposta: [null],
            observacao: [''],
          })
        );
      }
    } else if (currentLength > desiredLength) {
      for (let i = currentLength - 1; i >= desiredLength; i--) {
        this.formArray.removeAt(i);
      }
    }

    for (
      let i = 0;
      i < Math.min(this.formArray.length, this.itens.length);
      i++
    ) {
      const grupo = this.getFormGroup(i);
      const item = this.itens[i];
      if (grupo && item) {
        grupo.patchValue({
          perguntaId: item.id,
          perguntaNumero: item.numero,
          perguntaTexto: item.descricao,
        });
      }
    }
  }

  private initializeControls(): void {
    this.observacaoControls = [];

    if (!this.formArray) {
      return;
    }

    for (let i = 0; i < this.itens.length; i++) {
      const group = this.getFormGroup(i);
      if (group) {
        const control = new FormControl('');
        control.setValue(group.get('observacao')?.value || '');

        control.valueChanges.subscribe((value) => {
          group.get('observacao')?.setValue(value);
        });

        this.observacaoControls.push(control);
      } else {
        this.observacaoControls.push(new FormControl(''));
      }
    }
  }

  toggle(): void {
    this.isOpen = !this.isOpen;
  }

  getFormGroup(index: number): FormGroup | null {
    if (this.formArray && index < this.formArray.length) {
      return this.formArray.at(index) as FormGroup;
    }
    return null;
  }

  getObservacaoFormControl(index: number): FormControl {
    if (index < this.observacaoControls.length) {
      return this.observacaoControls[index];
    }
    return new FormControl('');
  }

  getRespostaControl(index: number): FormControl | null {
    const group = this.getFormGroup(index);
    return group ? (group.get('resposta') as FormControl) : null;
  }

  setResposta(index: number, value: number): void {
    const respostaControl = this.getRespostaControl(index);
    if (respostaControl) {
      respostaControl.setValue(value);
    }
  }

  isRespostaSelecionada(index: number, value: number): boolean {
    const respostaControl = this.getRespostaControl(index);
    return respostaControl ? respostaControl.value === value : false;
  }
}
